import React from 'react';
import InfoTip from './InfoTip';
import styles from './ToggleSwitch.module.css';
const {
    toggleSwitchContainer,
    toggleSwitchLabel,
    toggleSwitchWithTooltip,
    toggleSwitch,
    slider,
    labelTail,
    disabledContainer
} = styles;

const ToggleSwitch = ({ id, checked, onChange, label, tooltip, disabled = false }) => (
    <div className={`${toggleSwitchContainer}${disabled ? ` ${disabledContainer}` : ''}`}>
        <label className={toggleSwitchLabel} htmlFor={id}>
            {tooltip && typeof label === 'string' ? (
                // Icon inline after the text — never beside the switch (which
                // pushed it out of column) — and glued to the LAST WORD so a
                // wrapping label never strands the icon alone on its own line.
                <>
                    {label.split(' ').slice(0, -1).join(' ')}{' '}
                    <span className={labelTail}>
                        {label.split(' ').slice(-1)[0]}
                        <InfoTip text={tooltip} about={label} />
                    </span>
                </>
            ) : (
                <>
                    {label}
                    {tooltip && <InfoTip text={tooltip} />}
                </>
            )}
        </label>
        <div className={toggleSwitchWithTooltip}>
            <label className={toggleSwitch}>
                <input
                    type="checkbox"
                    id={id}
                    checked={checked}
                    disabled={disabled}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <span className={slider} />
            </label>
        </div>
    </div>
);

export default ToggleSwitch;
